import type { AgentSpec } from "@/features/agents/types";

export const ONBOARDING_OWNER = "onboarding";

/** What the onboarding page says about its agent (mirrors `registry.ONBOARDING`). */
export const ONBOARDING_SPEC: AgentSpec = {
  kind: "onboarding",
  scope_kind: "practice",
  label: "Onboarding",
  description:
    "Gets a new member set up: their tools, profile, agents and preferences, then the firm.",
  greeting: "Let's get you set up.",
  starters: [],
  supports_plan_mode: false
};
